module.exports = __webpack_public_path__ + "img/DE00687.bdb68a66.png";